import type { FaireProductEntity } from "../../entity_types/product";

export const p_4v3qdu3299: FaireProductEntity = {
  token: "p_4v3qdu3299",
  type: "product",
  name: "Try Me Trio - Organic Mineral Makeup Sampler",
  brandToken: "b_f2ec5373",
  brandName: "BEE-OCH Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/dd5dd76a72258d79e06902bb25cbb4d358c2513700bfc5216203246bc47380ac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2af7f3f0c5bf9675d663a26e1d770eeacd42f0f9a66e40a147eb004879c2afa2.jpeg",
    "https://cdn.faire.com/fastly/ef3ecdfefc0328b6b1f1aa93d1c0ae30db737553dccd58ad430155fe58a4ca69.webp",
    "https://cdn.faire.com/fastly/90e2e451164594242e774a28513ba933074671689fe71c9c13c548bb6bd5934b.jpeg",
    "https://cdn.faire.com/fastly/bbca12dbffa460749ea2ab2dbc9c5c212222a30b0996500b41046e5fd4aa9f3b.jpeg",
  ],
  priceDollars: 33.61,
  description:
    'Singles for you to try out our super-clean, bee-autiful coverage mineral makeup for yourself! All made with only organic ingredients and natural sunscreen minerals. Mineral Makeup Trio Includes:\n\nTinted Mineral Powder - 80% Natural Sunscreen Minerals (1 oz = 28 grams)\n\nTinted Mineral Foundation - 31% Natural Sunscreen Minerals (1/2 oz Twist Up Tube)\n\nTinted Lip Balm - 10% Natural Sunscreen Minerals (Colors: Royal Blush, Brick Rose, Peachy Dream)\n\nNOTE: Adding "testers" will also Include Tester Set & 5x Guide Cards with a wood-engraved stand for customers to take with their Trio! (pictured). ',
  tags: [],
  msrpDollars: 67.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:33.107Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
